import React from 'react';
import { Copy, Optional } from '@honda-canada/design-system-react';
import themeStyles from '../styles/Card.styles';
var ModelCodeCopy = themeStyles.apply(Copy, 'ModelCodeCopy');
var CardModelCode = function (_a) {
    var _b = _a.alignment, alignment = _b === void 0 ? 'center' : _b, modelCode = _a.modelCode;
    return (React.createElement(Optional, { when: modelCode },
        React.createElement(ModelCodeCopy, { size: "regular", alignment: alignment, "data-testid": "cy-uni-card-model-code" }, modelCode)));
};
export default CardModelCode;
